import type { RaRecord } from 'react-admin';

/**
 * Klucz stanu zlecenia dla paneli, które ładują dane zależne od tego stanu
 * (zapytania do przewoźników, publikacje na giełdach).
 *
 * Panel owinięty `recordScoped` żyje tak długo, jak rekord ma to samo id,
 * a po akcji na karcie (np. przekazaniu do Trade) react-admin odświeża TEN
 * SAM rekord. Panel, który ładował dane tylko przy zmianie id, pokazywał
 * dalej odmowę policzoną dla poprzedniego stanu — „zlecenie nie jest
 * przekazane do Trade” po przekazaniu (omówienie 01.10.2026). Zmiana klucza
 * = przeładowanie danych panelu.
 *
 * Stan planowania i obsadzenie wprost, bo od nich zależą odmowy; `updatedAt`
 * łapie resztę zmian zlecenia. Przeładowanie na zapas jest tanie,
 * przeoczone — nie.
 */
export function recordStateKey(record: RaRecord | null | undefined): string {
  if (!record) return '';
  return [record.planningStatus, record.assignedCarId, record.updatedAt]
    .map((v) => (v === undefined || v === null ? '' : String(v)))
    .join('|');
}
